// import getConfig from "next/config";
// const { publicRuntimeConfig } = getConfig();
// const environment = publicRuntimeConfig.ENVIRONMENT;

export const BASE_URL = process.env.BASE_URL;
export const SSO_BASE_URL = process.env.SSO_BASE_URL;
export const SSO_USER_URL = `${SSO_BASE_URL}/user`;
export const GOVMAIL_BASE_URL = process.env.GOVMAIL_BASE_URL;
export const CDE_BASE_URL = process.env.CDE_BASE_URL;
export const AI_BASE_URL = process.env.AI_BASE_URL;
export const INTEGRATION_URL = `${BASE_URL}/integration`;
export const HOST_AUTH_URL = `${BASE_URL}/web/auth/login`;
export const MERCHANT_AUTH_URL = `${SSO_BASE_URL}/auth/login`;
export const OTP_URL = `${SSO_BASE_URL}/auth/validate2faCode`;
export const HOST_BASE_URL = "/admin/host";
export const MERCHANT_BASE_URL = "/admin/tenant";
export const API_WEB_URL = `${BASE_URL}/web`;
export const MAKE_PAYMENT_VERIFICATION = process.env.MAKE_PAYMENT_VERIFICATION;
export const EKO_MAP_MAKE_PAYMENT_VERIFICATION_URL =
  process.env.EKO_MAP_MAKE_PAYMENT_VERIFICATION_URL;
// export const MAKE_PAYMENT_VERIFICATION = `http://localhost/wfmservice/api/orderid-verification`;
export const WFM_ACCESS_TOKEN = process.env.WFM_ACCESS_TOKEN;
// export const WFM_ACCESS_TOKEN = "oZaLJqhXqziuGsp5gZg8D4189DqN6gR3";
export const MAKE_PAYMENT_URL = process.env.MAKE_PAYMENT_URL;
export const UCG_AUTH_TOKEN = process.env.UCG_AUTH_TOKEN;
export const DOMAIN = process.env.DOMAIN;
export const COM_BASE_URL = process.env.COM_BASE_URL;
export const UCG_API_BASE_URL = process.env.UCG_API_BASE_URL;

// APP URLS
export const UCG = process.env.UCG_URL;
export const WFM = process.env.WFM_URL;
export const IMS = process.env.IMS_URL;
export const COM = process.env.COM_URL;

// FAQ URL
export const SUPPORT_URL = process.env.SUPPORT_URL;

// page routes without header/footer
export const pageRoutesWithoutLayout = [
  "/super-app",
  "/workflow-manager/ad",
  "/login"
]
